var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowBlackTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99988 5.66671C8.08761 5.6662 8.17459 5.68302 8.25581 5.71619C8.33704 5.74937 8.41092 5.79825 8.47321 5.86004L11.1399 8.52671C11.202 8.58886 11.2513 8.66266 11.285 8.74387C11.3186 8.82509 11.3359 8.91213 11.3359 9.00004C11.3359 9.08795 11.3186 9.17499 11.285 9.25621C11.2513 9.33742 11.202 9.41121 11.1399 9.47337C11.0777 9.53553 11.0039 9.58484 10.9227 9.61848C10.8415 9.65212 10.7544 9.66943 10.6665 9.66943C10.5786 9.66943 10.4916 9.65212 10.4104 9.61848C10.3292 9.58484 10.2554 9.53553 10.1932 9.47337L7.99988 7.26671L5.79988 9.38671C5.73855 9.4549 5.66381 9.50971 5.58033 9.5477C5.49686 9.58569 5.40644 9.60605 5.31474 9.6075C5.22304 9.60895 5.13202 9.59147 5.04739 9.55614C4.96275 9.52081 4.88631 9.4684 4.82286 9.40219C4.7594 9.33597 4.71029 9.25737 4.67859 9.17131C4.64689 9.08525 4.6333 8.99357 4.63865 8.90201C4.644 8.81045 4.66819 8.72099 4.70969 8.6392C4.7512 8.55742 4.80914 8.48508 4.87988 8.42671L7.54654 5.85337C7.66846 5.73583 7.83054 5.66909 7.99988 5.66671Z",
    fill: "#1B1C1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowBlackTop);
export default __webpack_public_path__ + "static/media/icon_arrow_black_top.935e6551ee2a50c5626b3a263205ec74.svg";
export { ForwardRef as ReactComponent };